import { render } from "./table-selection.vue?vue&type=template&id=40f5aa54"
import script from "./table-selection.vue?vue&type=script&lang=js"
export * from "./table-selection.vue?vue&type=script&lang=js"

import "./table-selection.vue?vue&type=style&index=0&id=40f5aa54&lang=scss"
script.render = render

export default script